import { render, staticRenderFns } from "./ProfileSkeleton.vue?vue&type=template&id=ae2e3360"
import script from "./ProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./ProfileSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports